import React from 'react';
import { Box, Button, Drawer, IconButton, styled, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { openContact } from '../../../redux/slices/profileSlice';
import CustomModal from '../../CustomModal';
import Image from '../../Image';
import userLock from '../../../assets/user-lock.png';
import useResponsive from '../../../hooks/useResponsive';
import Iconify from '../../Iconify';
import useLocales from '../../../hooks/useLocales';

const ContactButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  borderRadius: '30px',
  fontWeight: 600,
  fontSize: '16px',
  color: '#1a1a1a',
  background: theme.palette.gradients.buttonPrimary,
  boxShadow: 'none',
  '&:hover': {
    background: theme.palette.gradients.buttonPrimary,
    boxShadow: 'none',
  },
}));

const DeleteBankAccount = ({ handleClose, handleOpen }) => {
  const { translate } = useLocales();
  const dispatch = useDispatch();
  const isDesktop = useResponsive('up', 'lg');
  const { contactUs } = useSelector((state) => state.lookup);
  const navigate = useNavigate();

  console.log(contactUs);

  return (
    <>
      {isDesktop && (
        <CustomModal
          maxWidth={'xs'}
          hasClose={true}
          open={handleOpen}
          onClose={handleClose}
          actions={
            <ContactButton
              fullWidth
              onClick={() => {
                navigate('/');
                dispatch(openContact());
                handleClose();
              }}
            >
              {translate('contact_us')}
            </ContactButton>
          }
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 1,
              pt: 2,
              px: 3,
              width: '100%',
            }}
          >
            <Typography variant="subtitle1" fontWeight={600} textAlign="center" mb={1}>
              {translate('delete_bank_account')}
            </Typography>

            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
              }}
            >
              <Box>
                <Image src={userLock} style={{ width: 120, height: 120 }} alt="logout" />
              </Box>

              <Typography variant="h6" fontWeight={600}>
                {translate('opps')}
              </Typography>

              <Typography variant="body2" color="text.secondary">
                {translate('you_currently_unable')}
              </Typography>
            </Box>
          </Box>
        </CustomModal>
      )}

      {!isDesktop && (
        <Drawer
          anchor="right"
          maxWidth="xs"
          open={handleOpen}
          PaperProps={{
            sx: {
              width: '100%',
            },
          }}
        >
          <Box sx={{ p: 2, display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative' }}>
            <IconButton onClick={handleClose} sx={{ position: 'absolute', left: 8 }}>
              <Iconify icon="material-symbols:arrow-back-ios-new-rounded" />
            </IconButton>
            <Typography variant="h6" fontWeight={700}>
              {translate('delete_bank_account')}
            </Typography>
          </Box>

          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              p: 2,
              height: '100%',
              backgroundColor: '#F6F7F9',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
                backgroundColor: '#fff',
                p: 2,
              }}
            >
              <Box mb={'20px'}>
                <Image src={userLock} style={{ width: 180, height: 180 }} alt="logout" />
              </Box>

              <Typography variant="h6" fontWeight={600} mb={'32px'} fontSize={'24px'}>
                {translate('opps')}
              </Typography>

              <Typography fontSize={'14px'} fontWeight={500} color="text.secondary" mb={'32px'}>
                {translate('you_currently_unable')}
              </Typography>

              <ContactButton
                onClick={() => {
                  navigate('/');
                  dispatch(openContact());
                  handleClose();
                }}
                fullWidth
              >
                {translate('contact_us')}
              </ContactButton>
            </Box>
          </Box>
        </Drawer>
      )}
    </>
  );
};

export default DeleteBankAccount;
